export default __webpack_public_path__ + "static/media/folder.1bce8aa6.svg";